import React, { useState } from "react";
import { useEffect } from "react";
import "aos/dist/aos.css"; // Import the AOS styles
import AOS from "aos";

export default function Contact() {
  const [emailCopied, setEmailCopied] = useState(false);
  const [passwordCopied, setPasswordCopied] = useState(false);

  const emailAddress = "mahin.malek2005@gmail.com";
  // const subject = "Regarding your website";

  const mailtoLink = `mailto:${emailAddress}`;

  const handleCopyText = (copiedText, check) => {
    navigator.clipboard
      .writeText(copiedText)
      .then(() => {
        if (check === "EMAIL") {
          setEmailCopied(true);
        } else {
          setPasswordCopied(true);
        }
        setTimeout(() => {
          setEmailCopied(false);
          setPasswordCopied(false);
        }, 5000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  useEffect(() => {
    AOS.init(); // Initialize AOS
    AOS.refresh(); // Refresh AOS to detect new elements

    return () => {
      AOS.refreshHard(); // Cleanup AOS on component unmount
    };
  }, []);
  const CreateLinks = ({
    redirectLink,
    iconClassName,
    text,
    bgColor,
    anchorTitle,
    popupMSG,
  }) => {
    return (
      <>
        <a
          href={redirectLink}
          target="_blank"
          title={anchorTitle}
          rel="noopener noreferrer"
          className={`m-auto w-full relative group ts:text-xl vs:text-lg justify-center gap-3 h-10 flex hover:text-common-red hover:bg-gray-light rounded-lg text-white bg-${bgColor} border-2 border-${bgColor} transition-all duration-500`}
        >
          <i
            className={`${iconClassName} flex justify-center items-center `}
          ></i>
          <button>{text}</button>
          <div class="font-semibold w-max z-10 hidden group-hover:block absolute bg-white p-4 rounded-lg shadow-lg top-full left-1/2 transform -translate-x-1/2 mt-2">
            {popupMSG}
          </div>
        </a>
      </>
    );
  };

  return (
    <div
      className="bg-gray-light ts:h-fit  grid h-100vh max-h-fit items-center md:p-14 md:pb-2 vs:py-10 dark:bg-[#001840]"
      id="CONTACT"
    >
      <h1 className="vs:text-xl ts:text-4xl font-Ubuntu font-bold text-center dark:text-white">
        Take A{" "}
        <span className="text-common-red  border-b-4 border-common-red">
          Coffee
        </span>{" "}
        And{" "}
        <span className="text-common-red  border-b-4 border-common-red">
          Chat
        </span>{" "}
        With Me
      </h1>
      <div className=" vs:grid md:flex vs:justify-center md:justify-around items-center vs:gap-3 md:gap-5 w-full m-auto">
        <div className="vs:w-3/4 vs:my-10 sm:w-1/3 m-auto">
          <img
            src="Images/coofee-c.png"
            alt="Contact"
            data-aos="zoom-in-up"
            className="shadow-[#dc143c_20px_20px_5px_5px] dark:border-l-4 dark:border-t-4 dark:border-gray-300"
          />
        </div>
        <div className="grid grid-cols-2 ts:w-1/2 gap-2 md:gap-x-14 lg:gap-x-8 gap-y-4 items-start sm:w-3/4 md:w-1/3  lg:w-[30%] justify-center font-space vs:mt-5 md:mt-auto m-auto">
          <CreateLinks
            redirectLink="https://www.linkedin.com/in/mahin1112/"
            iconClassName="fa-brands fa-linkedin"
            text="LinkedIn"
            bgColor="common-red"
            anchorTitle="mahin-malek-371751286"
            popupMSG="New Linkedin Account! Let's Connect"
          />

          <CreateLinks
            redirectLink="https://www.instagram.com/mahi_.01112/"
            iconClassName="fa-brands fa-instagram"
            text="Instagram"
            bgColor="common-red"
            anchorTitle="Instagram"
            popupMSG="My IG"
          />

          <CreateLinks
            redirectLink="https://github.com/maahin2005"
            iconClassName="fa-brands fa-github"
            text="Github"
            bgColor="common-red"
            anchorTitle="maahin/2005"
            popupMSG="Unlock my code treasury"
          />
          <CreateLinks
            redirectLink="https://twitter.com/mahin_dev1112"
            iconClassName="fa-brands fa-twitter"
            text="Twitter"
            bgColor="common-red"
            anchorTitle="Twitter-X"
            popupMSG="Explore my Twitter"
          />

          <CreateLinks
            redirectLink={mailtoLink}
            iconClassName="fa-regular fa-envelope"
            text="Mail"
            bgColor="common-red"
            anchorTitle="mahin.malek2005@gmail.com"
            popupMSG="mahin.malek2005@gmail.com"
          />

          <CreateLinks
            redirectLink="https://wa.me/qr/LFOS2MISDEGIC1"
            iconClassName="fa-brands fa-whatsapp"
            text="WA"
            bgColor="common-red"
            anchorTitle="+91 7574990777"
            popupMSG="+91 75749 90777"
            //  & +918000172697
          />
          <div className="lg:px-5 px-2 min-w-fit w-full flex gap-3 sm:gap-5 items-center col-span-2 justify-center bg-white rounded-lg py-2">
            {" "}
            <i
              className={`fa-regular fa-envelope text-md sm:text-3xl text-red-600`}
            ></i>
            <p className="text-xs sm:text-sm md:text-md m-auto">
              mahin.malek2005@gmail.com
            </p>
            <i
              className={`${
                emailCopied
                  ? "fa-solid fa-clipboard-check icon-animation"
                  : "fa-solid fa-copy"
              } text-red-600 cursor-pointer text-md sm:text-xl transition-transform`}
              onClick={() =>
                handleCopyText("mahin.malek2005@gmail.com", "EMAIL")
              }
            ></i>
          </div>
          <div className="lg:px-5 px-2 min-w-fit w-full flex  gap-3 sm:gap-5 items-center col-span-2 justify-around bg-white rounded-lg py-2">
            {" "}
            <i
              className={`fa-solid fa-phone-volume text-md sm:text-3xl text-red-600`}
            ></i>
            <p className="text-xs sm:text-sm md:text-md m-auto">
              +91 75749 90777
            </p>
            <i
              className={`${
                passwordCopied
                  ? "fa-solid fa-clipboard-check icon-animation"
                  : "fa-solid fa-copy"
              } text-red-600 cursor-pointer  text-md sm:text-xl  transition-transform`}
              onClick={() => handleCopyText("+91 75749 90777", "PASSWORD")}
            ></i>
          </div>
        </div>
      </div>

      <h3 className="text-center font-space mt-5 dark:text-white">
        Designed and build by Mahin Malek, <br className="ts:hidden vs:block" />{" "}
        2024 All rights reserved.
      </h3>
    </div>
  );
}
